import React from 'react';

// SVG描画エラーを専門にキャッチするコンポーネント
function SVGErrorBoundary({ 
  children, 
  fallback = <div className="inline-flex items-center justify-center w-5 h-5 text-red-500 bg-red-50 rounded border border-red-200" title="Icon failed to load">⚠</div> 
}) {
  return (
    <ErrorBoundaryClass fallback={fallback}>
      {children}
    </ErrorBoundaryClass>
  );
}

class ErrorBoundaryClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorType: null };
  }

  static getDerivedStateFromError(error) {
    // SVG関連のエラーを特定
    const isSVGError = 
      error.message.includes('path') || 
      error.message.includes('SVG') ||
      error.message.includes('d attribute') ||
      error.message.includes('moveto');

    return { 
      hasError: true, 
      errorType: isSVGError ? 'SVG_ERROR' : 'UNKNOWN_ERROR'
    };
  }

  componentDidCatch(error, errorInfo) {
    // SVG エラーのみログ出力（スパム防止）
    if (this.state.errorType === 'SVG_ERROR') {
      console.warn('🎨 SVG rendering error caught:', {
        message: error.message,
        component: errorInfo.componentStack.split('\n')[1]?.trim()
      });
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}

// 安全なアイコンラッパー
export function SafeIcon({ IconComponent, className = "", size = 20, ...props }) {
  return (
    <SVGErrorBoundary 
      fallback={
        <div 
          className={`inline-flex items-center justify-center text-gray-400 ${className}`}
          style={{ width: size, height: size }}
          title="Icon loading failed"
        >
          ⚠
        </div>
      }
    >
      <IconComponent className={className} size={size} {...props} />
    </SVGErrorBoundary>
  );
}

export default SVGErrorBoundary;